// Class: lime.net._IHTTPRequest

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var _IHTTPRequest = function() {}

// Meta

_IHTTPRequest.__name__ = "lime.net._IHTTPRequest";
_IHTTPRequest.__isInterface__ = true;
_IHTTPRequest.prototype = {
	
};
_IHTTPRequest.prototype.__class__ = _IHTTPRequest.prototype.constructor = $hxClasses["lime.net._IHTTPRequest"] = _IHTTPRequest;

// Init



// Statics




// Export

exports.default = _IHTTPRequest;